import Vue from 'vue'
import Vuex from 'vuex'
import count from './modules/count'
import { login, dataReport, home, etcd, advertise, staff, subAccountGlobal, operationLog } from '@/global/store'
import accountInfo from './modules/accountInfo'
import advertiser from './modules/advertiser'
import subAccount from './modules/subAccount'
import agentAdvertise from './modules/advertise'
import financial from './modules/financial'
import group from './modules/group'
import plan from './modules/plan'
import creation from './modules/creation'
import promotion from './modules/promotion'
import channel from './modules/channel'
import transferEvent from './modules/transferEvent'
import promotionData from './modules/promotion-data'
import audience from './modules/audience'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    home: {
      namespaced: true,
      ...home
    },
    etcd: {
      namespaced: true,
      ...etcd
    },
    count: {
      namespaced: true,
      ...count
    },
    login: {
      namespaced: true,
      ...login
    },
    advertiser: {
      namespaced: true,
      ...advertiser
    },
    global: {
      namespaced: true,
      modules: {
        advertise: {
          namespaced: true,
          ...advertise
        },
        subAccount: {
          namespaced: true,
          ...subAccountGlobal
        },
        operationLog: {
          namespaced: true,
          ...operationLog
        }
      }
    },
    advertise: {
      namespaced: true,
      ...agentAdvertise
    },
    staff: {
      namespaced: true,
      ...staff
    },
    subAccount: {
      namespaced: true,
      ...subAccount
    },
    dataReport: {
      namespaced: true,
      ...dataReport
    },
    account: {
      namespaced: true,
      ...accountInfo
    },
    finance: {
      namespaced: true,
      ...financial
    },
    group: {
      namespaced: true,
      ...group
    },
    plan: {
      namespaced: true,
      ...plan
    },
    creation: {
      namespaced: true,
      ...creation
    },
    promotion,
    channel,
    transferEvent,
    promotionData,
    audience: {
      namespaced: true,
      ...audience
    }
  }
})
